import React from 'react'
import { useTranslation } from 'react-i18next'
import { TouchableOpacity, View } from 'react-native'
import { styles } from './styles'
import { BtText } from '@linqpal/components/src/ui'
import { CloseLines } from '../../../../../../assets/icons'

type HeaderProps = {
  onPress?: () => void
}
export const Header = ({ onPress }: HeaderProps) => {
  const { t } = useTranslation('global')
  return (
    <View style={styles.header}>
      <BtText style={styles.title}>{t('Projects.AddInvSOToProject')}</BtText>
      <TouchableOpacity style={styles.closeButton} onPress={onPress}>
        <CloseLines />
      </TouchableOpacity>
    </View>
  )
}
